<template>
  <div>
    <section class="baseslegales body-container">
      <div class="baseslegale-container">
        <div class="baseslegales-item">
          <h4>Acuerdo Hidragua</h4>
          <ul>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20e%20Inmob.%20Ayres%20Oriente%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Ayres Oriente S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20e%20Inmob.%20BBI%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. BBI S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20e%20Inmob.%20Lampa%20Oriente%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Lampa Oriente S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20e%20Inmob.%20Parque%20Chicureo%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Parque Chicureo S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20y%20Bricsa%20S.A.pdf" target="_blank"
                ><div class="bullet"></div>
                Bricsa S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Hidragua%20y%20Consorcio%20Inmobiliario%20MBI%20Ltda.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. MBI S.A.</a
              >
            </li>
          </ul>
        </div>
        <div class="baseslegales-item">
          <h4>Acuerdo Soc. Educ. Cabo de Hornos</h4>
          <ul>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Soc.%20Educ.%20Cabo%20de%20Hornos%20y%20Ayres%20Oriente%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Ayres Oriente S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Soc.%20Educ.%20Cabo%20de%20Hornos%20y%20Inmob.%20Parque%20Chicureo%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Parque Chicureo S.A.</a
              >
            </li>
          </ul>
        </div>
        <div class="baseslegales-item">
          <h4>Acuerdo Toproller</h4>
          <ul>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmb.%20Ayres%20Oriente%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Ayres Oriente S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmb.%20Lampa%20Oriente%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. BBI S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmb.%20Parque%20Chicureo%20S.A.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Lampa Oriente S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmob.%20BBI%20S.A..pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Parque Chicureo S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmob.%20Roberto%20del%20R%c3%ado%20SpA%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Roberto del Río SpA</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmob.%20Robles%20SpA%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Roble SpA</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20e%20Inmob.%20Za%c3%b1artu%20Spa%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. Zañartu SpA</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20y%20Bricsa%20S.A.pdf" target="_blank"
                ><div class="bullet"></div>
                Bricsa S.A.</a
              >
            </li>
            <li>
              <a href="https://www.bricsa.cl/mi-bricsa/media/documents/Acuerdo%20Toproller%20y%20Consorcio%20MBI%20Ltda.%20(21.09.2021).pdf" target="_blank"
                ><div class="bullet"></div>
                Inmob. MBI S.A.</a
              >
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.baseslegales {
    .baseslegale-container{
        display: flex;
        justify-content: center;
@media screen and (max-width:769px){
    display: grid;
    row-gap: 20px;
                width: 100%;
            }
        .baseslegales-item{
            width: fit-content;
            margin: 0 20px;
            @media screen and (max-width:769px){
                width: 100%;
            }
            h4{
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            a{
                color: #000;
                transition: 400ms;
                &:hover{
                    color: var(--bricsa-red);
                }
            }
        }
    }
  .bullet {
    width: 10px;
    height: 10px;
    background: var(--bricsa-red);
    margin-right: 5px;
    border-radius: 0px;
  }
}
</style>
